import {Component, OnInit} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {LmsHeaderCommonService} from '../service/lms-header-common.service';
import {UserManagementService} from '../../../../user-management/shared/services/user-management.service';
import {LogoutStrategyResolverService} from './logout-strategy-resolver.service';
import {getStoredJwtPayload} from '../../../token/jwt.helper';
import {GlobalConstants} from '../../../global-constants';
import {tap} from 'rxjs/operators';

@Component({
  selector: 'app-logout-confirm',
  templateUrl: './logout-confirm.component.html',
  styleUrls: ['./logout-confirm.component.scss'],
})
export class LogoutConfirmComponent implements OnInit {

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private readonly lmsHeaderCommonService: LmsHeaderCommonService,
    private readonly userManagementService: UserManagementService,
    private readonly logoutStrategyResolver: LogoutStrategyResolverService,
  ) {}
  decodeUUID: any = [];
  ngOnInit(): void {
    this.decodeUUID = getStoredJwtPayload() ?? {};
  }

  logout(): void {
    this.userManagementService.getUserType()
      .pipe(
        tap(res => this.logoutStrategyResolver.resolve(res.userType).execute(this.decodeUUID?.uuid)),
      ).subscribe();
  }

  // method to cancel notes submission
  cancel(): void {
    this.ref.destroy();
    this.getLoggedUserData();
  }

  getLoggedUserData(): void {
    if (localStorage.getItem(GlobalConstants.TOKEN) !== null) {
      this.lmsHeaderCommonService
        .getLoggedUser()
        .subscribe((res: any) => {
          this.lmsHeaderCommonService.setLoggedInUserData(res);
        });
    }
  }
}
